import Swal from 'sweetalert2';
import { get_token } from "@/router";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { export_personal_profile_form_table_csv } from "@/utils/csv_styling";

export default {
mounted() {
  this.getProfileTypes();
  this.preview();
  this.get_question_types();
},
beforeUnmount() {
  this.destroy_questions_datatable();
  this.destroy_personal_profile_form_datatables();
},
  data: () => ({
    questionDetails: [],
    token_exists: false,
    selectedQuestions: [],
    show_personal_profile_responses: false,
    personal_profile_forms_users: [],
    loading_personal_profile_forms: false,
    personal_profile_forms_loaded: false,
  }),
  watch: {
    '$route.params.section_id'() {
      this.preview();
    }
  },
  components: {
    Sidebar,
    Navbar,
  },
  computed: {
    selected_items() {
      const map = new Map(this.questionDetails.map(q => [q.question_id, q]));
      return this.selectedQuestions.map(id => map.get(id)).filter(Boolean);
    },
    assignable_questions() {
      return this.questionDetails.filter(q => !q.is_assigned_to_section);
    },
    assigned_questions_count() {
      return this.questionDetails.filter(q => q.is_assigned_to_section).length;
    },
    all_checked() {
      return this.assignable_questions.length > 0 &&
            this.selectedQuestions.length === this.assignable_questions.length;
    }
  },


  methods: {
    getToken() {
      return get_token();
    },

    getProfileTypes() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.profileTypes = response.data;
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load profile types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    preview() {
      this.token_exists = get_token();
      const section_id = Number(this.$route.params.section_id);
      const payload = section_id ? { section_id } : {};

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
        method: "POST",
        headers: this.token_exists
          ? {
              Authorization: `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            }
          : { 'Content-Type': 'application/json' },
        data: JSON.stringify(payload),
        processData: false,
        success: (response) => {
          const questionDetails = response.data.questions.map(question => ({
            question_id: question.id,
            question_name: question.question,
            question_type: question.question_type.question_type,
            is_assigned_to_section: question.is_assigned_to_section,
            assigning: false
          }));
          
          this.questionDetails = questionDetails;
          this.$nextTick(() => {
            if (this.dataTableInstance) {
              this.dataTableInstance.destroy();
              this.dataTableInstance = null;
            }
            this.dataTableInstance = $("#questionsTable").DataTable();
          });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load question types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    toggle_all(evt) {
      if (evt.target.checked) {
        this.selectedQuestions = this.assignable_questions.map(q => q.question_id);
      } else {
        this.selectedQuestions = [];
      }
    },

    remove_selected(question_id) {
      this.selectedQuestions = this.selectedQuestions.filter(id => id !== question_id);
    },

    toggle_personal_profile_responses() {
      if (!this.show_personal_profile_responses) {
        this.destroy_questions_datatable();
        this.show_personal_profile_responses = true;
        this.fetch_personal_profile_forms();
        return;
      }

      this.destroy_personal_profile_form_datatables();
      this.show_personal_profile_responses = false;
      this.$nextTick(() => {
        this.init_questions_datatable();
      });
    },

    init_questions_datatable() {
      if (!$.fn.DataTable || !$('#questionsTable').length || this.show_personal_profile_responses) {
        return;
      }

      if ($.fn.DataTable.isDataTable('#questionsTable')) {
        $('#questionsTable').DataTable().destroy();
      }

      $('#questionsTable').DataTable();
    },

    destroy_questions_datatable() {
      if (!$.fn.DataTable || !$('#questionsTable').length) {
        return;
      }

      if ($.fn.DataTable.isDataTable('#questionsTable')) {
        $('#questionsTable').DataTable().destroy();
      }
    },

    fetch_personal_profile_forms(force_reload = false) {
      if (this.loading_personal_profile_forms) {
        return;
      }

      if (this.personal_profile_forms_loaded && !force_reload) {
        this.$nextTick(() => {
          if (this.show_personal_profile_responses) {
            this.init_personal_profile_form_datatables();
          }
        });
        return;
      }

      this.loading_personal_profile_forms = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_personal_profile_forms/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.personal_profile_forms_users = Array.isArray(response.data) ? response.data : [];
            this.personal_profile_forms_loaded = true;
            this.$nextTick(() => {
              if (this.show_personal_profile_responses) {
                this.init_personal_profile_form_datatables();
              }
            });
          }
        },
        error: (xhr) => {
          console.error("Error fetching personal profile forms:", xhr);
          Swal.fire({
            icon: "error",
            title: "Failed to load responses",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
        complete: () => {
          this.loading_personal_profile_forms = false;
        }
      });
    },

    init_personal_profile_form_datatables() {
      if (!$.fn.DataTable || !this.show_personal_profile_responses) {
        return;
      }

      $('.assign-profile-form-table').each(function () {
        const table = $(this);

        if ($.fn.DataTable.isDataTable(this)) {
          table.DataTable().clear().destroy();
        }

        table.DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          scrollX: true,
          autoWidth: false,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available",
            search: "Search:"
          }
        });
      });
    },

    destroy_personal_profile_form_datatables() {
      if (!$.fn.DataTable) {
        return;
      }

      $('.assign-profile-form-table').each(function () {
        if ($.fn.DataTable.isDataTable(this)) {
          $(this).DataTable().destroy();
        }
      });
    },

    get_personal_profile_user_name(user) {
      return [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.email || 'Unknown user';
    },

    get_personal_profile_answer_cell(row, questionId) {
      return row?.answers?.[String(questionId)] || { text: '-', files: [] };
    },

    get_personal_profile_form_tables() {
      const formsMap = new Map();

      (this.personal_profile_forms_users || []).forEach((profileEntry) => {
        (profileEntry.forms || []).forEach((formEntry) => {
          if (!formEntry?.answers?.length || !formEntry?.form?.id) {
            return;
          }

          const formId = String(formEntry.form.id);
          if (!formsMap.has(formId)) {
            formsMap.set(formId, {
              form: formEntry.form,
              questions: [],
              rows: []
            });
          }

          const table = formsMap.get(formId);
          const answerMap = {};

          formEntry.answers.forEach((answer) => {
            const questionId = String(answer?.question?.id || answer?.id);
            const questionLabel = answer?.question?.question || 'Question';

            if (!table.questions.some((question) => String(question.id) === questionId)) {
              table.questions.push({
                id: questionId,
                question: questionLabel
              });
            }

            const fileNames = (answer.files || [])
              .map((fileItem) => fileItem?.file?.name)
              .filter(Boolean);

            let cellText = answer?.answer || '';
            if (fileNames.length) {
              const fileText = `Files: ${fileNames.join(', ')}`;
              cellText = cellText ? `${cellText} | ${fileText}` : fileText;
            }

            answerMap[questionId] = {
              text: cellText || '-',
              files: answer.files || []
            };
          });

          table.rows.push({
            user: profileEntry.user,
            base_profile_id: profileEntry.base_profile_id,
            answers: answerMap
          });
        });
      });

      return Array.from(formsMap.values());
    },

    export_personal_profile_form_table(formTable) {
      export_personal_profile_form_table_csv(formTable, {
        getUserName: this.get_personal_profile_user_name,
        getAnswerCell: this.get_personal_profile_answer_cell
      });
    },

    toggle_question_assignment(question, event) {
      if (!event?.target || question.assigning) {
        return;
      }

      const next_checked = event.target.checked;
      const current_checked = Boolean(question.is_assigned_to_section);

      if (next_checked === current_checked) {
        return;
      }

      const section_id = Number(this.$route.params.section_id);
      if (!section_id) {
        event.target.checked = current_checked;
        Swal.fire({
          icon: "warning",
          title: "No section selected",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      question.assigning = true;

      const request = next_checked
        ? this.assign_questions([question.question_id])
        : this.unassign_questions([question.question_id]);

      request
        .then(() => {
          question.is_assigned_to_section = next_checked;
        })
        .catch(() => {
          event.target.checked = current_checked;
        })
        .finally(() => {
          question.assigning = false;
        });
    },


get_question_types() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.question_types = response.data.question_types;
        },
        error: () => {
          Swal.fire({
            icon: "error",
           title: "Failed to load question types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    assign_selected() {
      const section_id = this.$route.params.section_id;
      if (!section_id) {
        Swal.fire({ icon: "warning", title: "No section selected" ,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
        });
        return;
      }
      if (this.selectedQuestions.length === 0) {
        Swal.fire({ icon: "info", title: "Select at least one question" ,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
        });
        return;
      }

      this.assign_questions(this.selectedQuestions)
        .then(() => {
          this.questionDetails = this.questionDetails.map(question => ({
            ...question,
            is_assigned_to_section: this.selectedQuestions.includes(question.question_id)
              ? true
              : question.is_assigned_to_section
          }));

          this.selectedQuestions = [];
        });
    },

    assign_questions(question_ids) {
      const section_id = Number(this.$route.params.section_id);
      const payload = {
        section_id,
        question_ids: question_ids.map(Number)
      };

      return new Promise((resolve, reject) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/assign_questions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          processData: false,
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Question assigned",
                text: "The question has been assigned to this section",
                showConfirmButton: false,
                timer: 1500,
                position: 'bottom-end',
                toast: true
              });
              resolve(response);
              return;
            }

            reject(response);
          },
          error: () => {
            Swal.fire({
              icon: "error",
              title: "Failed to assign question",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
            reject();
          }
        });
      });
    },

    unassign_questions(question_ids) {
      const section_id = Number(this.$route.params.section_id);
      const payload = {
        section_id,
        question_ids: question_ids.map(Number)
      };

      return new Promise((resolve, reject) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/unassign_questions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          processData: false,
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Question unassigned",
                text: "The question has been removed from this section",
                showConfirmButton: false,
                timer: 1500,
                position: 'bottom-end',
                toast: true
              });
              resolve(response);
              return;
            }

            reject(response);
          },
          error: () => {
            Swal.fire({
              icon: "error",
              title: "Failed to unassign question",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
            reject();
          }
        });
      });
    },

    fetchQuestions() {
      this.token_exists = get_token();
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`
          },
          success: (response) => {
            this.questions = response.data.questions;
            resolve();
          },
        });
      });
    }
  }
};

